<!-- <div class="search-fields m-t-20">
  <form class="client-search-criteria-form tab-grid" id="client-search-criteria" nz-form
    [formGroup]="clientSearchCriteriaForm" (ngSubmit)="attemptToSubmit()">
    <nz-form-item>
      <nz-form-label [nzSpan]="24"><span translate>First Name</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" formControlName="firstName" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24"><span translate>Last Name</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" formControlName="lastName" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24"><span translate>Date of Birth</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker style="width:100%" formControlName="dateOfBirth"
          [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="custSearchFor != 'POLICY'">
      <nz-form-label [nzSpan]="24"><span translate>Policy Number</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" formControlName="policyNum" />
      </nz-form-control>
    </nz-form-item>
  </form>
</div> -->

<div class="multisearch-grid">
  <div>
    <!-- <button nz-button nzType="primary" (click)="searchCustomer()">
      <span translate>Search for {{clientRole}}</span>
    </button> -->
  </div>
  <div></div>
  <div></div>
</div>
<div class="search-results m-t-20">
  <!-- Show Result Tables -->
  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="searchCustOrPolicyLoading">
    <!-- Customer Search Results -->
    <div>
      <!-- <nz-table *ngIf="clientDataSet && clientDataSet.length > 0" #clientSearchTable [nzData]="clientDataSet"
        [nzSize]="'middle'" [nzShowPagination]="true">
        <thead>
          <tr>
            <th>Client Number</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Date Of Birth</th>
            <th>Contact Number</th>
            <th>email ID</th>
            <th *ngIf="custSearchFor == 'POLICY'">Actions</th>
            <th *ngIf="custSearchFor == 'CLIENT'">Select</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let data of clientSearchTable.data">
            <tr *ngIf="data.clientNum">
              <td>{{data.clientNum}}</td>
              <td>{{data.firstName}}</td>
              <td>{{data.lastName}}</td>
              <td>{{getDateString(data.dateOfBirth)}}</td>
              <td>{{data.contactNum}}</td>
              <td>{{data.emailId}}</td>
              <td *ngIf="custSearchFor == 'POLICY'"><a (click)="viewAddCustomersPolicies(data)">View & Add Policies</a>
              </td>
              <td *ngIf="custSearchFor == 'CLIENT'">
                <button nz-button nzType="dashed" *ngIf="selectedCustomer?.clientNum == data.clientNum"
                  (click)="emitSelectedClient(data)">Selected</button>
                <button nz-button nzType="primary" *ngIf="selectedCustomer?.clientNum != data.clientNum"
                  (click)="emitSelectedClient(data)">Select</button>
              </td>
            </tr>
          </ng-container>
        </tbody>


      </nz-table> -->

      <!-- Zero list -->


      <!-- Policies for selected customer -->
      <div *ngIf="showCustomerPolicies && custSearchFor == 'POLICY'">
        <div class="heading-tab">
          <h3 class="heading">
            <i nz-icon nzType="file-text"></i> <span translate>Polices for</span> {{showCustomerPoliciesName}}
          </h3>
        </div>
        <nz-table *ngIf="policyDataSet && policyDataSet.length > 0" #policySearchTable [nzData]="policyDataSet"
          [nzSize]="'middle'" [nzShowPagination]="true">
          <thead>
            <tr>
              <th></th>
              <th><span translate>Proposal No</span></th>
              <th><span translate>Start Date</span></th>
              <th><span translate>Client Number</span></th>
              <th><span translate>First Name</span></th>
              <th><span translate>Last Name</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of policySearchTable.data">
              <td><label nz-checkbox [(ngModel)]="data['selected']"></label></td>
              <td>{{data.proposalNum}}</td>
              <td>{{getDateString(data.policyCommencementDt)}}</td>
              <td>{{data.clientNum}}</td>
              <td>{{data.firstName}}</td>
              <td>{{data.lastName}}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </nz-skeleton>
</div>

<!-- ************* Search UI ************* -->
<div class="ui-search-child">
<app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)" 
searchURL="searchInsured" itemsPerPage='100'></app-ui-search>
</div>

<div class="search-results m-t-20">
  <!-- Show Result Tables -->
  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="searchCustOrPolicyLoading">
    <!-- Customer Search Results -->
    <div>
      <nz-table *ngIf="dataSet && dataSet.length > 0" #clientSearchTable [nzData]="dataSet"
        [nzSize]="'middle'" [nzShowPagination]="true">
        <thead>
          <tr>
            <th>Client Number</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Date Of Birth</th>
            <th>Contact Number</th>
            <th>Email ID</th>
            <th *ngIf="custSearchFor == 'POLICY'">Actions</th>
            <th *ngIf="custSearchFor == 'CLIENT'">Select</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let data of clientSearchTable.data">
            <tr *ngIf="data.clientNum">
              <td>{{data.clientNum}}</td>
              <td>{{data.firstName}}</td>
              <td>{{data.lastName}}</td>
              <td>{{getDateString(data.dateOfBirth)}}</td>
              <td>{{data.contactNum}}</td>
              <td>{{data.emailId}}</td>
              <td *ngIf="custSearchFor == 'POLICY'"><a (click)="viewAddCustomersPolicies(data)">View & Add Policies</a>
              </td>
              <td *ngIf="custSearchFor == 'CLIENT'">
                <button nz-button nzType="dashed" *ngIf="selectedCustomer?.clientNum == data.clientNum"
                  (click)="emitSelectedClient(data)">Selected</button>
                <button id="selectButton" nz-button nzType="primary" *ngIf="selectedCustomer?.clientNum != data.clientNum"
                  (click)="emitSelectedClient(data)">Select</button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
<!-- ************* Search UI ************* -->